module.exports = __webpack_public_path__ + "static/media/isro.21e5c817.jpg";